// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__H7vKk","footer":"ModalFilter_footer__1UOqC"};